import React, { useRef, useState, useEffect } from "react";
import "../styles/contact.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ContactUs = () => {
  const formRef = useRef(null);
  const [isSent, setIsSent] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const sidePanelRef = useRef(null);
  const hamburgerRef = useRef(null);

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = {
      name: formRef.current['from_name'].value,
      number: formRef.current['number'] ? formRef.current['number'].value : '', // Add a field for number if needed
      email: formRef.current['email'].value,
      message: formRef.current['message'].value, // Use the message from the form
      type: 'contact'
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_PROD_API_URL}contact_email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      alert('Message sent successfully!');
      setIsSent(true);
    } catch (error) {
      console.error('Error sending message:', error);
      alert('There was an error sending your message. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sidePanelRef.current &&
        !sidePanelRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="contact-page">
      <Navbar />
      <div className="map-container">
        <img src="/assets/world-map.png" alt="world map" />
      </div>
      <div className="contactus-container">
        <div className="whatsapp-contact-card">
          <h2>Connect with Us on WhatsApp!</h2>
          <p>Need quick support? Chat with our team instantly on WhatsApp!</p>

          {/* Online Status Indicator */}
          <p>
            <strong>Support Status:</strong>
            <span style={{ color: "green", fontWeight: "bold" }}>
              {" "}
              We're Online!
            </span>
          </p>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/14372946051"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            💬 Chat on WhatsApp
          </a>

          {/* QR Code for WhatsApp */}
          <div className="whatsapp-qr">
            <p>Or scan the QR code to start chatting:</p>
            <img
              src="/assets/whatsapp_qr.png"
              alt="WhatsApp QR Code"
              width="120"
            />
          </div>

          {/* Call to Action */}
          <p style={{ fontSize: "14px", color: "#666" }}>
            Fast, free, and easy – get answers in seconds!
          </p>
        </div>

        <div className="contactus-form">
          <h2>Send Us A Message</h2>
          {isSent && (
            <p className="success-message">Message sent successfully!</p>
          )}
          <form ref={formRef} onSubmit={sendEmail}>
            <input
              type="text"
              name="from_name"
              placeholder="Your Name"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <input
              type="text"
              name="number"
              placeholder="Your Number"
            />
            <textarea
              name="message"
              placeholder="Your Message"
              required
            ></textarea>
            <button type="submit" disabled={loading}>
              {loading ? <span className="loader"></span> : "Send Message"}
            </button>
            {loading && (
              <div style={{ textAlign: 'center', marginTop: 10 }}>
                <span className="loader"></span> Sending...
              </div>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
